var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_390_2281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91655 17C9.76329 17 9.61416 16.9503 9.49155 16.8583L6.65822 14.7333C6.57025 14.6674 6.49884 14.5818 6.44967 14.4834C6.40049 14.3851 6.37488 14.2766 6.37488 14.1667V10.1858L1.40522 4.59496C1.05227 4.19679 0.82182 3.70516 0.741566 3.17917C0.661312 2.65317 0.73467 2.11519 0.952822 1.62988C1.17097 1.14458 1.52464 0.7326 1.9713 0.443463C2.41797 0.154327 2.93864 0.000336047 3.47072 0L13.5291 0C14.0611 0.000624078 14.5816 0.15487 15.0281 0.444201C15.4746 0.733532 15.828 1.14564 16.046 1.631C16.2639 2.11636 16.337 2.65432 16.2565 3.18024C16.1761 3.70616 15.9455 4.19765 15.5924 4.59567L10.6249 10.1858V16.2917C10.6249 16.4795 10.5503 16.6597 10.4174 16.7925C10.2846 16.9254 10.1044 17 9.91655 17ZM7.79155 13.8125L9.20822 14.875V9.91667C9.20836 9.74324 9.27213 9.57589 9.38743 9.44633L14.5356 3.65429C14.7073 3.46027 14.8193 3.22082 14.8582 2.96469C14.8971 2.70857 14.8613 2.44666 14.755 2.21039C14.6487 1.97413 14.4765 1.77357 14.2591 1.63277C14.0416 1.49198 13.7881 1.41694 13.5291 1.41667H3.47072C3.21179 1.41706 2.95847 1.49214 2.74114 1.6329C2.52381 1.77366 2.3517 1.97412 2.24545 2.21025C2.1392 2.44638 2.10332 2.70814 2.14212 2.96415C2.18091 3.22016 2.29274 3.45954 2.46418 3.65358L7.61305 9.44633C7.7281 9.57599 7.7916 9.74333 7.79155 9.91667V13.8125Z",
    fill: "#636E72"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_390_2281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.e9d0c249952c76539fadca417fc5076c.svg";
export { ForwardRef as ReactComponent };